import React from 'react';

import { EmptyIllustration } from '../empty-states/EmptyIllustration';

export default function ReactRouterErrorMessageBlock() {
  return <EmptyIllustration caption="There was an error loading this content" />;
}
